<template>
  <u-btn @click="$refs.popover.toggle()" color="white" size="sm" class="app-btn text-blue-grey-5" no-caps>
<!--    Mais filtros-->
    <u-icon name="filter" class="m-l__ fin-icon-filter" type="fa" />
    <u-popover :anchor-click="false" disable-close-on-click-outside @show="activated" ref="popover" class="window-context-menu wrapper min popover-effect fin-filtro-mais-popover" anchor="bottom left" self="top left"
               :offset="[0, 5]">
      <div class="simple-menu m-t-xs flex justify-between column full-width">
        <e-row class="col-grow-1 m-t" mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="Categoria:"
                label-width="90px"
            >
              <categoria-hirerarquia-select size="2" v-model="filters.categoria" />
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="ID da transação"
                label-width="90px"
            >
              <erp-input size="2" ref="input0" v-model="filters.id" @keydown.enter="buscar" style="max-width: 100px"/>
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row class="col-grow-1" mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="ID do leilão"
                label-width="90px"
            >
              <erp-input size="2" v-model="filters.relationEntityId" @keydown.enter="buscar" style="max-width: 100px"/>
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row class="col-grow-1" mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="Alguém"
                label-width="90px"
            >
              <fin-pessoa-input @keydown.enter.native="buscar" v-model="filters.pessoa" />
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row class="col-grow-1" mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="Centro de custo"
                label-width="90px"
            >
              <centro-custo-input @keydown.enter.native="buscar" v-model="filters.centroCusto" />
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row class="col-grow-1" mr>
          <e-col style="min-width: 170px" class="m-l m-r">
            <erp-s-field
                view="lr"
                label="Dedutível"
                label-width="90px"
            >
              <erp-select
                  :options="[
                    {label: 'Qualquer', value: null},
                    {label: 'Dedutível', value: true},
                    {label: 'Não Dedutível', value: false},
                  ]"
                  v-model="filters.dedutivel" />
            </erp-s-field>
          </e-col>
        </e-row>
        <e-row class="m-t" mr>
          <e-col class="text-right">
            <a @click="reset" class="m-r font-12">Remover filtros</a>
            <e-btn label="Buscar" @click="buscarFechar" />
          </e-col>
        </e-row>
      </div>
    </u-popover>
  </u-btn>
</template>

<script>
import {UPopover} from "uloc-vue"
import {ErpInput, ErpSField, ErpSelect} from "uloc-vue-plugin-erp"
import ECol from "@/components/layout/components/Col"
import ERow from "@/components/layout/components/Row"
import CentroCustoInput from "@/components/financeiro/components/input/CentroCustoInput"
import FinPessoaInput from "@/components/financeiro/components/input/PessoaInput"
import CategoriaHirerarquiaSelect from "@/components/financeiro/components/input/CategoriaHirerarquiaSelect";

export default {
  name: "FinFiltrosAdicionais",
  inject: ['container'],
  props: ['filters', 'stats'],
  components: {
    CategoriaHirerarquiaSelect,
    FinPessoaInput,
    CentroCustoInput,
    ERow,
    ECol,
    //MenuOptionsItem,
    UPopover,
    ErpSField,
    ErpInput,
    ErpSelect
  },
  mounted() {
  },
  watch: {
  },
  data() {
    return {
    }
  },
  methods: {
    activated() {
      this.$nextTick(() => {
        this.$refs.input0.focus()
      })
    },
    buscar () {
      this.container.table.filters.data1 = null
      this.container.table.filters.data2 = null
      this.container.table.filters.search = null
      this.container.pesquisar()
    },
    buscarFechar () {
      this.container.pesquisar()
      this.$refs.popover.hide()
    },
    reset () {
      this.container.table.filters.id = null
      this.container.table.filters.relationEntityId = null
      this.container.table.filters.pessoa = null
      this.container.table.filters.centroCusto = null
      this.$refs.popover.hide()
      this.container.pesquisar()
    }
  }
}
</script>
